module.exports = __webpack_public_path__ + "static/media/angle-right-black.54e68aec.svg";